import { createAction } from 'redux-actions';
import { actionKey } from './constants';

export const dreamupGenerationSucceeded = createAction(
  `${actionKey}.GENERATION_SUCCEEDED`,
  (generationId: number, deviationIds: number[]) => ({
    generationId,
    deviationIds,
  })
);

export const dreamupGenerationFailed = createAction(
  `${actionKey}.GENERATION_FAILED`,
  (
    generationId: number,
    freePromptsRemaining: number,
    errorCode: number | undefined
  ) => ({
    generationId,
    freePromptsRemaining,
    errorCode,
  })
);
